import { WSTableCell } from "@wingspanhq/fe-component-library";
import React from "react";
import { formatReportsValue } from "./formatReportsValue";

export const formatTableValue = (value?: any): React.ReactNode => {
  return <WSTableCell text={formatReportsValue(value)} />;
};
